import * as React from "react";
import ReactHtmlParser from "react-html-parser";

export interface MijnFNVLinkBlockProps {
  mainTitle: string;
  title: string;
  intro: string;
  link: string;
  visible: boolean;
  linkButtonText: string;
  openLinkInNewTab: boolean;
  additionalCssClass: string;
  layout: string;
  ctaImage : string;
  headerImage: string;
}

export class MijnFNVLinkBlock extends React.Component<MijnFNVLinkBlockProps> {
  render() {
    if (!this.props.visible) {
      return null;
    }
    
    let intro = ReactHtmlParser(this.props.intro);
    
    let link = this.props.link;
    if ((link || "").indexOf("~") == 0) {
      link = (link || "").slice(1);      
    }

    const layout = this.props.layout;
    let ctaImage = undefined;
    if (this.props.ctaImage && this.props.ctaImage !== "") {
      ctaImage = this.props.ctaImage;
      if ((ctaImage || "").indexOf("~") == 0) {
        ctaImage = (ctaImage || "").slice(1);      
      }
    }

    let headerImage = undefined;
    if (this.props.headerImage && this.props.headerImage !== "") {
      headerImage = this.props.headerImage;
      if ((headerImage || "").indexOf("~") == 0) {
        headerImage = (headerImage || "").slice(1);      
      }
    }
    
    let layoutCssClass = "";
    let buttonLayoutCssClass = "";
    let buttonStylingCssClass = "btn-success";
    let showOnlyButton = false;
    if (layout == "Gecentreerd-eenvoudig") {
      layoutCssClass = "mijn-fnv-link-block__centered";
      buttonLayoutCssClass = "justify-content-center";
      buttonStylingCssClass = "btn-outline-primary";
    } else if (layout == "Button-eenvoudig") {
      layoutCssClass = "mijn-fnv-link-block__centered";
      buttonLayoutCssClass = "justify-content-center";
      buttonStylingCssClass = "btn-outline-primary";
      showOnlyButton = true;
    }  else if (layout == "Button-waarschuwing") {
      layoutCssClass = "mijn-fnv-link-block__centered";
      buttonLayoutCssClass = "justify-content-center";
      buttonStylingCssClass = "btn-outline-danger";
      showOnlyButton = true;
    }

    return (
      <>
        {!showOnlyButton && this.props.mainTitle && <h2>{this.props.mainTitle}</h2>}
        <div
          id="fnv-form"
          className={"fnv-form__container mijn-fnv-link-block  widget  " + 
            (this.props.additionalCssClass || "") + " " + layoutCssClass}
        >
          <div
            className={"form form__react" + ( showOnlyButton ? " border-0 p-0" : "") }
          >
            <div className="form__section form__section-default  "></div>
            <div className="form__section  ">
              {!showOnlyButton && <div className="form__panel ">
                <h3 className="form__panel-title">{this.props.title}</h3>
              </div>}
              {!showOnlyButton && headerImage && <img src={headerImage} className="mijn-fnv-link-block__header-image" />}
              <div className="form-group  form__section-input">
                <label title={intro}>
                  {intro}
                </label>
                <div className="input-group">
                  <span
                    className="form-control-plaintext"
                    data-value="-"
                    title=""
                  >
                    -
                  </span>
                </div>
              </div>
              <div className="form-group-after "></div>
              <div className={"form__custom-panel form__custom-panel--link d-flex " + buttonLayoutCssClass}>
                <a href={link}
                  target={this.props.openLinkInNewTab ? "_blank" : ""}
                  className={layout == "Standaard" ? 
                    "btn btn-primary button-align-right" : 
                    "btn " + buttonStylingCssClass}
                >{this.props.linkButtonText}</a>
              </div>
            </div>
            <div className="row no-gutters"></div>
            {layout == "CTA Block" && ctaImage && <img src={ctaImage} className="mijn-fnv-link-block__cta-image" />}
          </div>
        </div>
      </>
    );

    //return null;
  }
}
